import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {TranslateModule} from '@ngx-translate/core';

import {UiModule} from '../ui/ui.module';
import {EmployeeSelectComponent} from './employee-select.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    UiModule
  ],
  declarations: [
    EmployeeSelectComponent
  ],
  exports: [
    EmployeeSelectComponent
  ]
})
export class EmployeeSelectModule {
}
